
document.addEventListener('DOMContentLoaded', function() {
  var audio = new Audio();
  audio.src='https://cdn.shopify.com/s/files/1/0657/2805/3385/files/AUD-Lyfer-Bird-Call-2s.mp3';
  
  audio.preload = 'auto';
  
  var clickableElements = document.querySelectorAll('h1.header__logo');
  clickableElements.forEach(function(element) {
    element.addEventListener('mouseover', function() {
        audio.play();
      });

    element.addEventListener('mouseleave', function() {
      audio.pause();
      audio.currentTime = 0;
    }, false);
    
  });
});
